import React, { useState, useEffect } from 'react';
import api from '@http/api';

import TableNoPagination from '../../Tables/TableColapseNoPaginationIR';
import { Grid } from '@material-ui/core';
import { FormatDate } from '@utils/formats';
import InvisibleContent from '@src/components/Shared/InvisibleContent';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { useSnackbar } from 'notistack';

import Destinacao from './Destinacao';
import DoacaoAnual from './DoacaoAnual';

interface ILista {
  tipoContribuicao: string;
  documentoImposto: string;
  linkS3: string;
  dataInserida: string;
  ano: string;
  projetoNome: string;
  fundoNome: string;
}

const columnsLabel = {
  dataInserida: 'Data inserida',
  tipoContribuicao: 'Contrib.',
  documentoImposto: 'Documento',
  ano: 'Ano',
  linkS3: 'Arquivo',
};

let fundo: any;

interface IProps {
  idPerfil: number;
  formaContrib: string;
}

const IR: React.FC<IProps> = ({
  idPerfil,
  formaContrib
  //fundo,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ILista[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  const [statusDestinacao, setStatusDestinacao] = useState('Destinacao');
  const [statusDoacao, setStatusDoacao] = useState('Doacao anual');


  useEffect(() => {
    async function loadData() {
      setLoading(true);
      try {
        const response = await api.get(`api/ContribuicoesDarf/ListagemPerfil?perfilId=${idPerfil}`)

        const items = response.data.documentos || [];
        if (items.length > 0) {

          const itemData: ILista[] = items.map((item: ILista) => ({
            dataInserida: FormatDate(item.dataInserida),
            tipoContribuicao: item.tipoContribuicao,
            documentoImposto: item.documentoImposto,
            ano: item.ano,
            fundoNome: item.fundoNome,
            projetoNome: item.projetoNome,
            linkS3: item.linkS3,
          }));

          setData(itemData);
          setLoading(false);
        } else {
          setData([]);
          enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
            variant: 'info',
          });
        }
      } catch (error) {
        console.error('Erro ao carregar doações:', error);

      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [idPerfil]);


  console.log("MEU DEUS", formaContrib)

   return (
    <>
      <Grid
        container
        alignItems="center"
        item
        lg={12}
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >
 <InvisibleContent visible={formaContrib === 'DESTINAÇÃO IR'}>
        <Grid item lg={4} md={4} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5 }}
            color={statusDestinacao === 'Destinacao' ? 'primary' : 'default'}
          >
            Destinação
          </ButtonComponent>
        </Grid>
        </InvisibleContent>
        <InvisibleContent visible={formaContrib === 'DOAÇÃO IR'}>



        <Grid item lg={4} md={4} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={statusDoacao === 'Doacao anual' ? 'primary' : 'default'}
          >
            Doação anual
          </ButtonComponent>
        </Grid>
        </InvisibleContent>
      </Grid>


      <InvisibleContent visible={formaContrib === 'DESTINAÇÃO IR'}>
        <Destinacao idPerfil={idPerfil}/>
      </InvisibleContent>

      <InvisibleContent visible={formaContrib === 'DOAÇÃO IR'}>
        <DoacaoAnual idPerfil={idPerfil}/>
      </InvisibleContent>


    </>
  );
};

export default IR;
